// extracted by mini-css-extract-plugin
export default {"table":"table--syOI1","loading":"loading--ofX70","slidein":"slidein--uTgxN"};